export default "/build/images/pressure_mask.20ab8b0f.png";